import { useState } from "react";
import EditNavbarItemsPermissionsForm from "./EditNavbarItemsPermissionsForm";
import DialogFormPanel from "../../../../../../../../../../shared/components/panel/DialogFormPanel";
import UpdateButtonTrigger from "../../../../../../../../../../shared/components/button/UpdateButtonTrigger";

const EditNavbarItemsPermissionsDialog = ({ onSubmitHandler, navbarItem }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger />}
      title="Editar menús de navegación"
      description="Editar la configuración de los menús de acceso de la barra superior de navegación del Control Centre"
      content={
        <EditNavbarItemsPermissionsForm
          onSubmitHandler={onSubmit}
          navbarItem={navbarItem}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default EditNavbarItemsPermissionsDialog;
